import type { PermissionKey } from "@bookdental/schemas";
import { useAuth } from "./auth";

/** Permissão efetiva na organização ativa, já resolvida pelo servidor (`me.current`) — a mesma
 *  fonte que o Sidebar usa pra esconder item de menu. Serve pra esconder/desabilitar CONTROLE na
 *  tela; a autorização de verdade é sempre o `permissionProcedure` do backend. Sem organização
 *  ativa, nega (fail-closed), igual ao servidor. */
export function usePermissao(key: PermissionKey): boolean {
  const { user } = useAuth();
  return user?.activeOrganization?.permissions?.[key] ?? false;
}
